import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSanitize from 'rehype-sanitize';

export default function MarkdownRenderer({ content }) {
  return (
    <div className='markdown-content'>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        components={{
          img: ({ node, ...props }) => (
            <img {...props} style={{ maxWidth: '100%', height: 'auto' }} alt={props.alt || ''} />
          ),
          a: ({ node, ...props }) => {
            const isExternal = props.href && !props.href.startsWith('/');
            return (
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              <a
                {...props}
                {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              />
            );
          },
          table: ({ node, ...props }) => (
            <div className='table-responsive'>
              <table className='table table-striped table-bordered' {...props} />
            </div>
          ),
        }}
      >
        {content || ''}
      </ReactMarkdown>
    </div>
  );
}
